import {dataTestId} from '@hconnect/uikit'
import {CardBox, Loader} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import React from 'react'

import {usePermission} from '../../../../permissions'

import {StrengthTargets} from './StrengthTargets'

import {useLatestData} from '@settings/modules/common/hooks/useLatestData'

export const MaterialSettingsTargetsTab: React.FC = () => {
  const canChangeTargets = usePermission('ASSIGN_MASTER_DATA_PROCESS')
  const {timezone_id: timezone} = useLatestData()

  if (!timezone) {
    return (
      <CardBox>
        <Loader />
      </CardBox>
    )
  }

  return (
    <Stack spacing={3} {...dataTestId('cement_targets')}>
      <StrengthTargets isReadOnly={!canChangeTargets} timezone={timezone} />
    </Stack>
  )
}
